import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://orszadaqarjquwgqpijw.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9yc3phZGFxYXJqcXV3Z3FwaWp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ0MDU1NzcsImV4cCI6MjA2OTk4MTU3N30.iB4EbNDoQPlJhT30YV4dL_DzhefphtvqBVOAT23Dq14';

export const supabase = createClient(supabaseUrl, supabaseKey);
window.supabase = supabase;
